import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { CheckboxSvg } from 'components/icons';
import { Icon, Title } from './atoms';

const template = styled.div`
  display: flex;
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Checkbox',
      displayValue: ({ checked }) => CheckboxSvg({ checked })
    },
    {
      component: Title,
      name: 'Title',
      displayValue: ({ label }) => label,
      displayState: ({ checked }) => ({ checked }),
    },
  ],
})